import { tv, type VariantProps } from 'tailwind-variants';

import { Button, type ButtonProps } from './Button';

const iconButtonVariants = tv({
  base: 'p-2 rounded-full',
});

export interface IconButtonProps extends VariantProps<typeof iconButtonVariants>, ButtonProps {}

export function IconButton({ children, className, ...props }: IconButtonProps): React.ReactElement {
  return (
    <Button fill="ghost" className={iconButtonVariants({ ...props, className })} {...props}>
      {children}
    </Button>
  );
}
